import { createContext, useContext, useState, useEffect } from 'react';

// Translation strings
const translations = {
  de: {
    // Navigation
    nav_home: 'Home',
    nav_inventory: 'Fahrzeuge',
    nav_sold_cars: 'Verkaufte Fahrzeuge',
    nav_we_find: 'Wir finden',
    nav_about: 'Über uns',
    nav_contact: 'Kontakt',
    nav_favorites: 'Merkliste',
    nav_compare: 'Vergleich',
    
    // Sold Cars Page
    sold_cars_title: 'Verkaufte Fahrzeuge',
    sold_cars_subtitle: 'Ein Blick auf unsere Referenzen',
    sold_cars_description: 'Diese Fahrzeuge haben wir bereits erfolgreich an zufriedene Kunden vermittelt. Ihr Traumauto ist noch nicht dabei? Kontaktieren Sie uns – wir finden es für Sie.',
    sold_cars_empty: 'Aktuell sind keine verkauften Fahrzeuge zu zeigen.',
    
    // We Find Page
    we_find_title: 'Wir finden Ihr Wunschfahrzeug',
    we_find_intro_headline: 'Ihr Wunschfahrzeug war noch nicht dabei?',
    we_find_intro_text: 'Teilen Sie uns einfach mit, wonach Sie suchen – wir machen uns auf die Suche und melden uns, sobald wir ein passendes Fahrzeug gefunden haben.',
    we_find_section_vehicle: 'Fahrzeugwünsche',
    we_find_section_equipment: 'Ausstattung',
    we_find_section_wishes: 'Sonstige Wünsche',
    we_find_section_contact: 'Kontaktdaten',
    we_find_brand: 'Marke',
    we_find_model: 'Modell',
    we_find_year_from: 'Baujahr von',
    we_find_year_to: 'Baujahr bis',
    we_find_price_from: 'Preis von (€)',
    we_find_price_to: 'Preis bis (€)',
    we_find_max_mileage: 'Kilometer max.',
    we_find_vehicle_type: 'Fahrzeugtyp',
    we_find_fuel: 'Kraftstoff',
    we_find_transmission: 'Getriebe',
    we_find_colors: 'Farbe(n)',
    we_find_min_hp: 'Mindest-PS',
    we_find_drivetrain: 'Antrieb',
    we_find_wishes_placeholder: 'z.B. bevorzugte Region, Zustand, spezielle Anforderungen …',
    we_find_first_name: 'Vorname',
    we_find_last_name: 'Nachname',
    we_find_email: 'E-Mail',
    we_find_phone: 'Telefon',
    we_find_preferred_contact: 'Bevorzugter Kontakt',
    we_find_preferred_email: 'E-Mail',
    we_find_preferred_phone: 'Telefon',
    we_find_preferred_any: 'Egal',
    we_find_submit: 'Anfrage absenden',
    we_find_submitting: 'Wird gesendet…',
    we_find_success_title: 'Ihre Anfrage ist eingegangen',
    we_find_success_message: 'Danke! Wir melden uns bei Ihnen, sobald wir ein passendes Fahrzeug gefunden haben.',
    we_find_required_note: 'Pflichtfelder sind mit * markiert.',
    we_find_error: 'Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es später erneut.',
    we_find_select: 'Bitte wählen',
    we_find_select_optional: 'Optional',
    
    // Hero
    hero_subtitle: 'PREMIUM FAHRZEUGE',
    hero_title: 'Finden Sie Ihr Traumauto',
    hero_description: 'Entdecken Sie unsere kuratierte Sammlung der außergewöhnlichsten Automobile der Welt. Wo Leidenschaft auf Leistung trifft.',
    hero_cta: 'Fahrzeuge ansehen',
    hero_secondary: 'Mehr erfahren',
    
    // Search Filters
    search_placeholder: 'Nach Modell suchen...',
    filter_brand: 'Marke',
    filter_fuel: 'Kraftstoff',
    filter_transmission: 'Getriebe',
    filter_color: 'Farbe',
    filter_price: 'Preis',
    filter_year: 'Baujahr',
    filter_horsepower: 'Leistung',
    filter_mileage: 'Kilometer',
    filter_all_brands: 'Alle Marken',
    filter_all_types: 'Alle Typen',
    filter_all_colors: 'Alle Farben',
    filter_reset: 'Filter zurücksetzen',
    filter_search: 'Fahrzeuge suchen',
    filter_advanced: 'Erweiterte Filter',
    filter_vehicle_type: 'Fahrzeugtyp',
    filter_doors: 'Türen',
    filter_show_more: 'Mehr Filter anzeigen',
    filter_show_less: 'Weniger Filter anzeigen',
    filter_clear_all: 'Alle löschen',
    filter_more: 'Filter',
    filter_search_btn: 'Suchen',
    vehicle_type_new: 'Neuwagen',
    vehicle_type_used: 'Gebrauchtwagen',
    vehicle_type_demo: 'Vorführwagen',
    vehicle_type_rental: 'Mietwagen',
    doors: 'Türen',
    hp: 'PS',
    
    // Featured Cars
    featured_subtitle: 'UNSERE AUSWAHL',
    featured_title: 'Premium Fahrzeuge',
    featured_description: 'Handverlesene Automobile für anspruchsvolle Kenner',
    featured_view_all: 'Alle Fahrzeuge',
    
    // About Section
    about_subtitle: 'ÜBER UNS',
    about_years: 'Jahre Erfahrung',
    about_cars: 'Verkaufte Autos',
    about_satisfaction: 'Zufriedenheit',
    
    // Video Section
    video_subtitle: 'EINBLICK',
    video_play: 'Video abspielen',
    
    // Contact Section
    contact_subtitle: 'KONTAKT',
    contact_name: 'Ihr Name',
    contact_email: 'Ihre E-Mail',
    contact_message: 'Ihre Nachricht',
    contact_send: 'Nachricht senden',
    contact_sending: 'Wird gesendet...',
    
    // Newsletter
    newsletter_subtitle: 'NEWSLETTER',
    newsletter_title: 'Bleiben Sie informiert',
    newsletter_description: 'Erhalten Sie wöchentlich Updates zu neuen Premium-Fahrzeugen direkt in Ihr Postfach.',
    newsletter_name: 'Ihr Name (optional)',
    newsletter_email: 'Ihre E-Mail-Adresse',
    newsletter_subscribe: 'Anmelden',
    newsletter_success: 'Vielen Dank für Ihre Anmeldung!',
    newsletter_success_sub: 'Sie erhalten bald Ihren ersten Newsletter.',
    newsletter_privacy: 'Sie können sich jederzeit abmelden. Wir respektieren Ihre Privatsphäre.',
    
    // Footer
    footer_navigation: 'Navigation',
    footer_contact: 'Kontakt',
    footer_hours: 'Öffnungszeiten',
    footer_privacy: 'Datenschutz',
    footer_terms: 'AGB',
    footer_imprint: 'Impressum',
    footer_rights: 'Alle Rechte vorbehalten.',
    
    // Cars Page
    cars_subtitle: 'Unsere Kollektion',
    cars_title: 'Fahrzeuge',
    cars_description: 'Entdecken Sie unsere komplette Sammlung an Premium- und Exklusivfahrzeugen. Jedes Fahrzeug wurde sorgfältig ausgewählt und geprüft.',
    cars_no_results: 'Keine Fahrzeuge gefunden',
    cars_no_results_hint: 'Passen Sie Ihre Filter an, um mehr Ergebnisse zu sehen.',
    cars_found_singular: 'Fahrzeug gefunden',
    cars_found_plural: 'Fahrzeuge gefunden',
    
    // Favorites Page
    favorites_title: 'Meine Merkliste',
    favorites_description: 'Ihre gespeicherten Fahrzeuge. Behalten Sie Ihre Favoriten im Blick und vergleichen Sie sie.',
    favorites_empty: 'Ihre Merkliste ist leer',
    favorites_empty_hint: 'Stöbern Sie durch unsere Kollektion und speichern Sie Ihre Lieblingsfahrzeuge.',
    favorites_browse: 'Fahrzeuge entdecken',
    favorites_count_singular: 'Fahrzeug gespeichert',
    favorites_count_plural: 'Fahrzeuge gespeichert',
    
    // Compare Page
    compare_title: 'Fahrzeugvergleich',
    compare_subtitle: 'Vergleichen Sie bis zu 4 Fahrzeuge',
    compare_empty: 'Noch keine Fahrzeuge im Vergleich',
    compare_add: 'Fahrzeug hinzufügen',
    compare_add_short: 'Hinzufügen',
    compare_clear: 'Vergleich löschen',
    compare_vehicle: 'Fahrzeug',
    compare_view_details: 'Details ansehen',
    compare_tips_title: 'Vergleichshinweise',
    compare_tip_best: 'Grün markierte Werte zeigen den besten Wert in der Kategorie',
    compare_tip_price: 'Rot markierte Preise zeigen den höchsten Preis',
    compare_tip_add: 'Fügen Sie bis zu 4 Fahrzeuge für einen vollständigen Vergleich hinzu',
    compare_picker_title: 'Fahrzeug zum Vergleich hinzufügen',
    compare_all_added: 'Alle Fahrzeuge sind bereits im Vergleich',
    compare_max_error: 'Maximal 4 Autos vergleichen',
    compare_already_error: 'Auto bereits im Vergleich',
    compare_added: 'Auto hinzugefügt',
    compare_removed: 'Auto entfernt',
    compare_cleared: 'Vergleich gelöscht',
    
    // Car Detail
    detail_price: 'Preis',
    detail_year: 'Baujahr',
    detail_mileage: 'Kilometer',
    detail_fuel: 'Kraftstoff',
    detail_transmission: 'Getriebe',
    detail_horsepower: 'Leistung',
    detail_color: 'Farbe',
    detail_doors: 'Türen',
    detail_inquire: 'Anfrage senden',
    detail_compare: 'Zum Vergleich',
    detail_favorite: 'Merken',
    detail_financing: 'Finanzierung berechnen',
    detail_similar: 'Ähnliche Fahrzeuge',
    detail_about: 'Über dieses Fahrzeug',
    detail_send_inquiry: 'Anfrage absenden',
    detail_your_name: 'Ihr Name',
    detail_your_email: 'Ihre E-Mail',
    detail_your_message: 'Ihre Nachricht',
    detail_subscribe: 'Newsletter abonnieren',
    
    // Inquiry
    inquiry_title: 'Interesse an diesem Fahrzeug?',
    inquiry_subtitle: 'Senden Sie uns eine Nachricht und wir melden uns schnellstmöglich.',
    inquiry_newsletter: 'Ich möchte den wöchentlichen Newsletter mit neuen Premium-Fahrzeugen erhalten',
    inquiry_success: 'Anfrage erfolgreich gesendet!',
    inquiry_success_sub: 'Wir melden uns so schnell wie möglich bei Ihnen.',
    
    // General
    loading: 'Wird geladen...',
    error: 'Ein Fehler ist aufgetreten',
    success: 'Erfolgreich',
    hp: 'PS',
    km: 'km',
    newsletter_already: 'Sie sind bereits für den Newsletter angemeldet',
    car_not_found: 'Fahrzeug nicht gefunden',
    back_to_inventory: 'Zurück zu Fahrzeuge',
    back_to_cars: 'Zurück zu Fahrzeuge'
  },
  en: {
    // Navigation
    nav_home: 'Home',
    nav_inventory: 'Vehicles',
    nav_sold_cars: 'Sold Vehicles',
    nav_we_find: 'We Find',
    nav_about: 'About Us',
    nav_contact: 'Contact',
    nav_favorites: 'Favorites',
    nav_compare: 'Compare',
    
    // Sold Cars Page
    sold_cars_title: 'Sold Vehicles',
    sold_cars_subtitle: 'A look at our references',
    sold_cars_description: 'These vehicles have already found happy new owners. Not seeing your dream car? Contact us – we\'ll find it for you.',
    sold_cars_empty: 'No sold vehicles to display at the moment.',
    
    // We Find Page
    we_find_title: 'We\'ll Find Your Dream Car',
    we_find_intro_headline: 'Couldn\'t find your dream car?',
    we_find_intro_text: 'Just let us know what you\'re looking for – we\'ll start the search and get back to you as soon as we find a matching vehicle.',
    we_find_section_vehicle: 'Vehicle Preferences',
    we_find_section_equipment: 'Equipment',
    we_find_section_wishes: 'Additional Wishes',
    we_find_section_contact: 'Contact Details',
    we_find_brand: 'Brand',
    we_find_model: 'Model',
    we_find_year_from: 'Year from',
    we_find_year_to: 'Year to',
    we_find_price_from: 'Price from (€)',
    we_find_price_to: 'Price to (€)',
    we_find_max_mileage: 'Max. mileage',
    we_find_vehicle_type: 'Vehicle type',
    we_find_fuel: 'Fuel',
    we_find_transmission: 'Transmission',
    we_find_colors: 'Colour(s)',
    we_find_min_hp: 'Min. HP',
    we_find_drivetrain: 'Drivetrain',
    we_find_wishes_placeholder: 'e.g. preferred region, condition, special requirements …',
    we_find_first_name: 'First name',
    we_find_last_name: 'Last name',
    we_find_email: 'Email',
    we_find_phone: 'Phone',
    we_find_preferred_contact: 'Preferred contact',
    we_find_preferred_email: 'Email',
    we_find_preferred_phone: 'Phone',
    we_find_preferred_any: 'Either',
    we_find_submit: 'Send request',
    we_find_submitting: 'Sending…',
    we_find_success_title: 'Your request has been received',
    we_find_success_message: 'Thanks! We\'ll get back to you as soon as we\'ve found a suitable vehicle.',
    we_find_required_note: 'Required fields are marked with *.',
    we_find_error: 'Could not submit request. Please try again later.',
    we_find_select: 'Please select',
    we_find_select_optional: 'Optional',
    
    // Hero
    hero_subtitle: 'PREMIUM VEHICLES',
    hero_title: 'Find Your Dream Car',
    hero_description: 'Discover our curated collection of the world\'s most exceptional automobiles. Where passion meets performance.',
    hero_cta: 'Browse Vehicles',
    hero_secondary: 'Learn More',
    
    // Search Filters
    search_placeholder: 'Search by model...',
    filter_brand: 'Brand',
    filter_fuel: 'Fuel Type',
    filter_transmission: 'Transmission',
    filter_color: 'Color',
    filter_price: 'Price',
    filter_year: 'Year',
    filter_horsepower: 'Horsepower',
    filter_mileage: 'Mileage',
    filter_all_brands: 'All Brands',
    filter_all_types: 'All Types',
    filter_all_colors: 'All Colors',
    filter_reset: 'Reset Filters',
    filter_search: 'Search Vehicles',
    filter_advanced: 'Advanced Filters',
    filter_vehicle_type: 'Vehicle Type',
    filter_doors: 'Doors',
    filter_show_more: 'Show more filters',
    filter_show_less: 'Show less filters',
    filter_clear_all: 'Clear all',
    filter_more: 'Filters',
    filter_search_btn: 'Search',
    vehicle_type_new: 'New',
    vehicle_type_used: 'Used',
    vehicle_type_demo: 'Demo',
    vehicle_type_rental: 'Rental',
    doors: 'Doors',
    hp: 'HP',
    
    // Featured Cars
    featured_subtitle: 'OUR SELECTION',
    featured_title: 'Premium Vehicles',
    featured_description: 'Handpicked automobiles for discerning enthusiasts',
    featured_view_all: 'View All',
    
    // About Section
    about_subtitle: 'ABOUT US',
    about_years: 'Years Experience',
    about_cars: 'Cars Sold',
    about_satisfaction: 'Satisfaction',
    
    // Video Section
    video_subtitle: 'INSIGHT',
    video_play: 'Play Video',
    
    // Contact Section
    contact_subtitle: 'CONTACT',
    contact_name: 'Your Name',
    contact_email: 'Your Email',
    contact_message: 'Your Message',
    contact_send: 'Send Message',
    contact_sending: 'Sending...',
    
    // Newsletter
    newsletter_subtitle: 'NEWSLETTER',
    newsletter_title: 'Stay Informed',
    newsletter_description: 'Get weekly updates on new premium vehicles delivered straight to your inbox.',
    newsletter_name: 'Your Name (optional)',
    newsletter_email: 'Your Email Address',
    newsletter_subscribe: 'Subscribe',
    newsletter_success: 'Thank you for subscribing!',
    newsletter_success_sub: 'You will receive your first newsletter soon.',
    newsletter_privacy: 'You can unsubscribe at any time. We respect your privacy.',
    
    // Footer
    footer_navigation: 'Navigation',
    footer_contact: 'Contact',
    footer_hours: 'Opening Hours',
    footer_privacy: 'Privacy Policy',
    footer_terms: 'Terms',
    footer_imprint: 'Imprint',
    footer_rights: 'All rights reserved.',
    
    // Cars Page
    cars_subtitle: 'Our Collection',
    cars_title: 'Vehicles',
    cars_description: 'Explore our complete collection of premium and exotic vehicles. Each car has been carefully selected and inspected to meet our exacting standards.',
    cars_no_results: 'No vehicles found',
    cars_no_results_hint: 'Try adjusting your filters to see more results.',
    cars_found_singular: 'vehicle found',
    cars_found_plural: 'vehicles found',
    
    // Favorites Page
    favorites_title: 'My Wishlist',
    favorites_description: 'Your saved vehicles. Keep track of your favorite cars and compare them easily.',
    favorites_empty: 'Your wishlist is empty',
    favorites_empty_hint: 'Start browsing our collection and save your favorite vehicles.',
    favorites_browse: 'Browse Vehicles',
    favorites_count_singular: 'vehicle saved',
    favorites_count_plural: 'vehicles saved',
    
    // Compare Page
    compare_title: 'Vehicle Comparison',
    compare_subtitle: 'Compare up to 4 vehicles',
    compare_empty: 'No vehicles in comparison yet',
    compare_add: 'Add Vehicle',
    compare_add_short: 'Add',
    compare_clear: 'Clear Comparison',
    compare_vehicle: 'Vehicle',
    compare_view_details: 'View Details',
    compare_tips_title: 'Comparison Tips',
    compare_tip_best: 'Green highlighted values show the best value in the category',
    compare_tip_price: 'Red highlighted prices show the highest price',
    compare_tip_add: 'Add up to 4 vehicles for a complete comparison',
    compare_picker_title: 'Add Vehicle to Comparison',
    compare_all_added: 'All vehicles are already in comparison',
    compare_max_error: 'Maximum 4 cars can be compared',
    compare_already_error: 'Car already in comparison',
    compare_added: 'Car added',
    compare_removed: 'Car removed',
    compare_cleared: 'Comparison cleared',
    compare_remove: 'Remove',
    
    // Car Detail
    detail_price: 'Price',
    detail_year: 'Year',
    detail_mileage: 'Mileage',
    detail_fuel: 'Fuel',
    detail_transmission: 'Transmission',
    detail_horsepower: 'Horsepower',
    detail_color: 'Color',
    detail_doors: 'Doors',
    detail_inquire: 'Send Inquiry',
    detail_compare: 'Add to Compare',
    detail_favorite: 'Save',
    detail_financing: 'Calculate Financing',
    detail_similar: 'Similar Vehicles',
    detail_about: 'About This Vehicle',
    detail_send_inquiry: 'Send Inquiry',
    detail_your_name: 'Your Name',
    detail_your_email: 'Your Email',
    detail_your_message: 'Your Message',
    detail_subscribe: 'Subscribe to Newsletter',
    
    // Inquiry
    inquiry_title: 'Interested in this vehicle?',
    inquiry_subtitle: 'Send us a message and we will get back to you as soon as possible.',
    inquiry_newsletter: 'I would like to receive the weekly newsletter with new premium vehicles',
    inquiry_success: 'Inquiry sent successfully!',
    inquiry_success_sub: 'We will get back to you as soon as possible.',
    
    // General
    loading: 'Loading...',
    error: 'An error occurred',
    success: 'Success',
    hp: 'HP',
    km: 'km',
    newsletter_already: 'You are already subscribed to our newsletter',
    car_not_found: 'Car Not Found',
    back_to_inventory: 'Back to Inventory',
    back_to_cars: 'Back to Cars'
  }
};

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    // Check localStorage first, then browser language
    const saved = localStorage.getItem('app_language');
    if (saved && (saved === 'de' || saved === 'en')) {
      return saved;
    }
    // Default to German
    return 'de';
  });

  useEffect(() => {
    localStorage.setItem('app_language', language);
    document.documentElement.lang = language;
  }, [language]);

  const t = (key) => {
    return translations[language][key] || translations['de'][key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'de' ? 'en' : 'de');
  };

  return (
    <LanguageContext.Provider value={{ 
      language, 
      setLanguage, 
      toggleLanguage,
      t,
      isGerman: language === 'de',
      isEnglish: language === 'en'
    }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
}
